import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { useSnackbar } from "../context/SnackbarContext";
import { failureDetail } from "./useCertificateTemplates";

/**
 * A Certificates mutation that refreshes every query under `queryKey` (awaited,
 * so `mutateAsync` resolves once the list is fresh) and shows a toast if it fails.
 */
export const useCertificatesWrite = <Variables, Result>(
  write: (variables: Variables, token: string) => Promise<Result>,
  failureMessage: string,
  queryKey: readonly string[],
) => {
  const { token } = useAuth();
  const { showMessage } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: Variables) => {
      if (!token) throw new Error("No token");
      return write(variables, token);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
    onError: (error) => {
      console.error(failureMessage, error);
      showMessage({
        message: failureMessage + failureDetail(error),
        severity: "error",
      });
    },
  });
};
